import { Component } from '@angular/core';
import {VERSION} from '@angular/cli';
import GlobalComponent from '../../global-component';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
  standalone: true,
})
export class FooterComponent {
  protected version = GlobalComponent.VERSION;
}
